import { Skeleton } from '@verlo/shared/components/ui/skeleton';

/**
 * One skeleton per shape (Back Office Review, wave A), so a loading page looks like the
 * page it's about to be rather than a spinner in the middle of nothing.
 *
 *   <Loading shape="tiles" count={4} />   a row of Stats
 *   <Loading shape="table" rows={8} />    a DataTable
 *   <Loading shape="form" />              a settings card
 */
const Loading = ({ shape = 'table', count = 4, rows = 6, className, testId = 'loading' }) => {
  if (shape === 'tiles') {
    return (
      <div className={`grid grid-cols-2 gap-3 md:grid-cols-${Math.min(count, 4)} ${className || ''}`} data-testid={testId} aria-busy>
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className="rounded-lg border border-hairline bg-white px-4 py-3">
            <Skeleton className="h-2.5 w-16" /><Skeleton className="mt-3 h-6 w-24" /><Skeleton className="mt-2 h-2.5 w-20" />
          </div>
        ))}
      </div>
    );
  }
  if (shape === 'form') {
    return (
      <div className={`rounded-lg border border-hairline bg-white p-5 ${className || ''}`} data-testid={testId} aria-busy>
        <Skeleton className="h-4 w-40" />
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="mt-4"><Skeleton className="h-2.5 w-24" /><Skeleton className="mt-2 h-9 w-full" /></div>
        ))}
      </div>
    );
  }
  return (
    <div className={`overflow-hidden rounded-lg border border-hairline bg-white ${className || ''}`} data-testid={testId} aria-busy>
      <div className="flex gap-6 border-b border-hairline bg-surface-2 px-4 py-2.5">
        {[24, 40, 20, 16].map((w, i) => <Skeleton key={i} className="h-2.5" style={{ width: `${w}%` }} />)}
      </div>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex gap-6 border-b border-hairline px-4 py-3 last:border-0">
          {[24, 40, 20, 16].map((w, j) => <Skeleton key={j} className="h-3" style={{ width: `${w}%` }} />)}
        </div>
      ))}
    </div>
  );
};

export default Loading;
